__turbopack_context__.v({
  "actions": "CDedicatedContactForm-module__5T6lYW__actions",
  "contactBlock": "CDedicatedContactForm-module__5T6lYW__contactBlock",
  "contactBlockBody": "CDedicatedContactForm-module__5T6lYW__contactBlockBody",
  "contactBlockIcon": "CDedicatedContactForm-module__5T6lYW__contactBlockIcon",
  "contactBlockLabel": "CDedicatedContactForm-module__5T6lYW__contactBlockLabel",
  "contactBlockValue": "CDedicatedContactForm-module__5T6lYW__contactBlockValue",
  "contactBlocks": "CDedicatedContactForm-module__5T6lYW__contactBlocks",
  "fieldError": "CDedicatedContactForm-module__5T6lYW__fieldError" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["errorText"],
  "fieldRow": "CDedicatedContactForm-module__5T6lYW__fieldRow",
  "fieldsGrid": "CDedicatedContactForm-module__5T6lYW__fieldsGrid",
  "fieldsSection": "CDedicatedContactForm-module__5T6lYW__fieldsSection",
  "form": "CDedicatedContactForm-module__5T6lYW__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "formCol": "CDedicatedContactForm-module__5T6lYW__formCol",
  "formTitle": "CDedicatedContactForm-module__5T6lYW__formTitle" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["formTitle"],
  "hero": "CDedicatedContactForm-module__5T6lYW__hero",
  "heroDescription": "CDedicatedContactForm-module__5T6lYW__heroDescription",
  "heroEyebrow": "CDedicatedContactForm-module__5T6lYW__heroEyebrow",
  "heroInner": "CDedicatedContactForm-module__5T6lYW__heroInner",
  "heroTitle": "CDedicatedContactForm-module__5T6lYW__heroTitle",
  "infoCol": "CDedicatedContactForm-module__5T6lYW__infoCol",
  "intro": "CDedicatedContactForm-module__5T6lYW__intro",
  "layout": "CDedicatedContactForm-module__5T6lYW__layout",
  "mapWrap": "CDedicatedContactForm-module__5T6lYW__mapWrap",
  "root": "CDedicatedContactForm-module__5T6lYW__root",
  "sectionHeader": "CDedicatedContactForm-module__5T6lYW__sectionHeader",
  "sideCard": "CDedicatedContactForm-module__5T6lYW__sideCard",
  "sideCardBody": "CDedicatedContactForm-module__5T6lYW__sideCardBody",
  "sideCardTitle": "CDedicatedContactForm-module__5T6lYW__sideCardTitle",
  "subjectSelect": "CDedicatedContactForm-module__5T6lYW__subjectSelect",
});
